function mainRender() {
 $(function () {
  $("#root").css("zoom", "normal");
  let scale = document.body.clientWidth / 1080;
  $("#root").css("zoom", scale);

  window.addEventListener(
   "resize",
   (function () {
    var timer;
    return function () {
     if (timer) clearTimeout(timer);
     timer = setTimeout(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);
     }, 100);
    };
   })()
  );
  // 头部固定
  $("header").addClass("stiky");
  $(document).scroll(function (e) {
   var beforScrollTop = $(document).scrollTop();
   setTimeout(function () {
    $("header").addClass("stiky");
   }, 50);
  });
  // 首屏轮播
  new Swiper(".SpSwiper", {
   slidesPerView: 1.8,
   spaceBetween: 0,
   centeredSlides: true,
   loop: true,
   autoplay: {
    delay: 2000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
   },
  });
  new Swiper("#swiper2", {
   loop: true,
   centeredSlides: true,
   spaceBetween: 20,
   slidesPerView: 2.15,
   freeMode: true,
   speed: 5500, //匀速时间
   autoplay: {
    delay: 0,
    stopOnLastSlide: false,
    disableOnInteraction: false,
   },
  });
  // 弹窗
  $(".sp-size-btn").click(function () {
   $(".mask").css("display", "flex");
   $(".mask .size-pop").css("display", "flex");
   $(".mask .img-pop").css("display", "none");
  });
  $(".close-btn").click(function () {
   $(".mask").hide();
  });
  $(".close-pop").click(function () {
   $(".mask").hide();
  });

  $(".mask").click(function (e) {
   if ($(e.target).closest(".mask .btn").length > 0) {
   } else {
    // $(".mask").hide();
   }
  });
 });

 function lazyLoadImages() {
  // 懒加载
  const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
  const config = {
   rootMargin: "0px 0px 1300px 0px",
   threshold: 0,
  };

  const lazyLoadObserver = new IntersectionObserver(function (
   entries,
   observer
  ) {
   entries.forEach(function (entry) {
    if (entry.isIntersecting) {
     // 当图片进入视口时
     const image = entry.target;
     const dataSrc = image.getAttribute("data-src");
     image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
     lazyLoadObserver.unobserve(image); // 停止观察该图片
    }
   });
  },
  config);

  images.forEach(function (image) {
   lazyLoadObserver.observe(image); // 开始观察每个图片
  });
 }

 function preloadImages(imageArray) {
  // 预加载
  // 检查数组数据结构
  if (Array.isArray(imageArray[0])) {
   // 处理二维数组
   imageArray.forEach((subArray) => {
    subArray.forEach((url) => {
     const img = new Image();
     img.src = url;
    });
   });
  } else {
   // 处理一维数组
   imageArray.forEach((url) => {
    const img = new Image();
    img.src = url;
   });
  }
 }

 document.addEventListener("DOMContentLoaded", function () {
  lazyLoadImages();

  preloadImages(select_array);
  // preloadImages(imagesTwoDim)

  // 找到所有跳转套餐的锚点链接
  var links = document.querySelectorAll('a[href^="#shopping"]');
  links.forEach(function (link) {
   link.addEventListener("click", function (event) {
    event.preventDefault(); // 阻止默认的跳转行为
    // var targetElement = document.getElementById('shopping');
    // if (targetElement) {
    //     targetElement.scrollIntoView({ behavior: 'smooth' });
    // } // 方式一
    const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
    // const offsetTop = targetElement.offsetTop - $('.sp-header-bottom').height() - $('.sp-header-top').height()
    const offsetTop = targetElement.offsetTop;
    window.scroll({
     top: offsetTop * $("div#root").css("zoom"),
     behavior: "smooth", // 使用 smooth 实现平滑滚动
    }); // 方式二
   });
  });
 });

 // IOS字体多了间距的处理 给节点添加 sp_system 类名
 // 判断当前用户是安卓端还是iOS端
 var userAgent = navigator.userAgent || navigator.vendor || window.opera;
 var isAndroid = /android/i.test(userAgent);
 var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
 var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

 if (isAndroid) {
  console.log("Android");
 } else if (isIOS) {
  console.log("iOS");
 } else if (isPC) {
  console.log("PC");
 } else {
  $(".sp_system").css("letter-spacing", "-4px");
 }

 let select_array = [
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select1.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select2.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select3.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select4.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select5.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select6.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select7.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select8.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select9.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select10.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select11.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select12.png",
  "https://cdn.shopifycdn.net/s/files/1/0569/0340/1562/files/select13.png",
 ];

 function changeImage(index) {
  $(".product-part .select_img").attr("src", select_array[index]);
 }

 $(".color_box div").click(function () {
  changeImage($(this).index());
 });

 $(".options div").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  changePrice();
 });

 let prods = window.product;
 function getCur() {
  let color = $(".color_box div.active").attr("data-val");
  let size = $(".size_box  div.active").attr("data-val");
  return prods.filter(
   (item) => item.option1 == color && item.option2 == size
  )[0];
 }
 function changePrice() {
  let num = $("#calcNumber").val();
  let price = ((getCur().price * num) / 100).toFixed(2);
  let compare = ((getCur().compare_at_price * num) / 100).toFixed(2);
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $(".product-part .price_box .price1 span").html(price);
  $(".product-part .price_box .price2 span").html(compare);
  let off_font =
   100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100);
  $(".product-part .price_box .off_box span").html(off_font);
 }

 $(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
   input.value = num;
  }
  changePrice();
 });
 $(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice();
 });

 $(".buyNow").click(function () {
  let num = $("#calcNumber").val();
  window.location.href = "/cart/" + getCur().id + ":" + num;
 });

 $(".cart_btn").click(function () {
  // do something here
  var data = {
   id: getCur().id,
   quantity: $("#calcNumber").val(),
  };

  $.ajax({
   type: "POST",
   url: "/cart/add.js",
   data: data,
   success: function () {
    $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
     $(".buy-car span").html(result.item_count);
    });
   },
   dataType: "json",
  });

  var img = $(".select_img");
  var flyer = img[0].cloneNode(true);
  flyer.classList.add("clone");
  $(".buy-car").append(flyer);
  $(".clone").css({
   width: img.width(),
   height: img.height(),
   position: "fixed",
   top: img[0].offsetTop,
   left: img.offset().left,
   "z-index": "99",
  });
  var offset = $(".buy-car")[0].getBoundingClientRect();
  let finish = $(".buy-car");
  $(".clone").animate(
   {
    top: offset.top,
    left: offset.left + finish.width() / 2,
    width: 50, // 结束时的大小，根据需要调整
    height: 50, // 结束时的大小，根据需要调整
    opacity: 0.4,
   },
   800,
   "linear",
   function () {
    $(this).animate(
     {
      width: 0,
      height: 0,
      opacity: 0,
     },
     0,
     function () {
      $(this).detach(); // 完成动画后移除克隆的图片
     }
    );
   }
  );
 });
}

mainRender();
